<template>
  <div>
    <ai-report-detail-container />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AiReportDetailContainer from "@/container/ai-report/AiReportDetailContainer.vue";

export default defineComponent({
  components: { AiReportDetailContainer },
});
</script>
